/* eslint-disable */
import { MenuItem, Select } from "@mui/material";

const CustomFormEnumSelect = ({name, register, id, requiredMessage, list, onChange, ...restProps}) => {
    return (
        <Select
            {...restProps}
            sx={{
                backgroundColor: "inherit",
                "& .MuiOutlinedInput-notchedOutline>legend":{overflow:"unset"},
                "& .MuiOutlinedInput-notchedOutline>legend>span":{opacity:"unset", color:"#fff",backgroundColor:"gray",borderRadius:"5px",position:"relative",top:"-5px"}
            }}
            {...register(name, {
                required : requiredMessage
            })}
            onChange={onChange}
        >
            <MenuItem 
            disabled
            sx={{display : 'none'}}
            key="empty"
            value={''}>
                <em>None</em>
            </MenuItem>
            {list && list.map((opt) => (
            <MenuItem key={opt.code} value={opt.code}>
                {opt.title}
            </MenuItem> 
            ))}
        </Select>
    );
};

export default CustomFormEnumSelect;